import { useContext } from 'react'

import { ConfigContext } from './ConfigContext'

export const useConfigContext = () => {
  const context = useContext(ConfigContext)

  if (!context)
    throw new Error(
      'You forgot to wrap your component in <ConfigContextProvider>',
    )

  return context
}
